/**
 * Utility functions for determining application phases
 */

/**
 * Determines the current phase of an application based on completed sections
 * @param application The application data
 * @returns The current phase (Verifizierung/Deutschkenntnisse/Defizitbescheid/Arbeitsmarktzulassung/Visum/Einreise/Integration)
 */
export const getApplicationPhase = (application: any): string => {
  // Check all phase requirements (from highest to lowest)

  // Phase 1: Deutschkenntnisse
  // - German language >= B1
  // - German language school not "other"
  // - German language certificate uploaded
  const hasGermanLanguageRequirements =
    application.german_language_skills &&
    ["b1", "b2", "c1", "c2"].includes(application.german_language_skills) &&
    application.language_school &&
    application.language_school !== "other" &&
    application.german_language_certificate;

  if (hasGermanLanguageRequirements) {
    return "Deutschkenntnisse";
  }

  // Default fallback to Verifizierung (no logic - just fallback)
  return "Verifizierung";
};
